var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.545 18a9 9 0 100-18 9 9 0 000 18zm0-15.94a7 7 0 110 14 7 7 0 010-14zM15.705 19.54h-.32c-5.32 0-8.13.38-10.49 2.46-2 1.73-2.4 4.58-1.28 8.44a1.2 1.2 0 001.16.87h21.54a1.19 1.19 0 001.16-.87c1.13-3.87.7-6.71-1.28-8.44-2.36-2.08-5.19-2.46-10.49-2.46zm10 9.77H5.375c-.37-1.47-.91-4.25.84-5.81 1.75-1.56 4.37-2 9.16-2h.34c4.79 0 7.28.31 9.16 2s1.23 4.34.84 5.81h-.01z"
  })));
}

export default SvgUser;